var map = {
	"./csv.svg": "0344",
	"./doc.svg": "8cb2",
	"./docx.svg": "a97d",
	"./jpg.svg": "4c12",
	"./key.svg": "d769",
	"./numbers.svg": "03a0",
	"./ods.svg": "a761",
	"./odt.svg": "f672",
	"./pages.svg": "e7e2",
	"./pdf.svg": "5456",
	"./png.svg": "9622",
	"./ppt.svg": "b521",
	"./pptx.svg": "c5c4",
	"./teacher.svg": "6dc9",
	"./txt.svg": "e2ac",
	"./www.svg": "aa6d",
	"./xls.svg": "b9d8",
	"./xlsx.svg": "0e1c",
	"./xml.svg": "9dcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";